var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomersNavIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3644_123483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 5.32C13.0547 5.32 13.9098 4.46486 13.9098 3.41C13.9098 2.35514 13.0547 1.5 11.9998 1.5C10.945 1.5 10.0898 2.35514 10.0898 3.41C10.0898 4.46486 10.945 5.32 11.9998 5.32Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14062 8.17982C9.14062 7.42131 9.44195 6.69385 9.9783 6.1575C10.5147 5.62114 11.2421 5.31982 12.0006 5.31982C12.7591 5.31982 13.4866 5.62114 14.023 6.1575C14.5593 6.69385 14.8606 7.42131 14.8606 8.17982",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6405 16.7702C20.6953 16.7702 21.5505 15.9151 21.5505 14.8602C21.5505 13.8053 20.6953 12.9502 19.6405 12.9502C18.5856 12.9502 17.7305 13.8053 17.7305 14.8602C17.7305 15.9151 18.5856 16.7702 19.6405 16.7702Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7695 19.64C16.7682 19.2628 16.8416 18.889 16.9853 18.5402C17.1291 18.1914 17.3404 17.8745 17.6072 17.6077C17.874 17.3409 18.1909 17.1296 18.5397 16.9858C18.8885 16.842 19.2623 16.7687 19.6395 16.77C20.016 16.77 20.3887 16.8443 20.7363 16.9887C21.084 17.133 21.3997 17.3446 21.6654 17.6112C21.9311 17.8779 22.1416 18.1943 22.2847 18.5425C22.4279 18.8906 22.5009 19.2636 22.4995 19.64",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.35922 16.7702C5.41408 16.7702 6.26922 15.9151 6.26922 14.8602C6.26922 13.8053 5.41408 12.9502 4.35922 12.9502C3.30435 12.9502 2.44922 13.8053 2.44922 14.8602C2.44922 15.9151 3.30435 16.7702 4.35922 16.7702Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.50002 19.64C1.4987 19.2636 1.57171 18.8906 1.71485 18.5425C1.85798 18.1943 2.06844 17.8779 2.33415 17.6112C2.59985 17.3446 2.91558 17.133 3.26323 16.9887C3.61087 16.8443 3.98359 16.77 4.36002 16.77C4.73728 16.7687 5.11108 16.842 5.45988 16.9858C5.80868 17.1296 6.12559 17.3409 6.39236 17.6077C6.65913 17.8745 6.87048 18.1914 7.01424 18.5402C7.15801 18.889 7.23134 19.2628 7.23002 19.64",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.4707 11.3699C2.57584 9.77453 3.08066 8.23125 3.9387 6.88216C4.79673 5.53307 5.9804 4.42153 7.3807 3.6499",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6191 3.6499C18.0194 4.42153 19.2031 5.53307 20.0611 6.88216C20.9192 8.23125 21.424 9.77453 21.5291 11.3699",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39062 21.79C10.7041 22.737 13.2971 22.737 15.6106 21.79",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3644_123483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersNavIcon);
export default __webpack_public_path__ + "static/media/customers_nav_icon.9c393c2cc1e8e694b3b06120e9dde6dd.svg";
export { ForwardRef as ReactComponent };